<template>
<div>
	<BaseModal :config="IssuanceModalLabel"
	           @ResetFields="resetFields"
	           @SaveChanges="saveChanges">
		<div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
			<form ref="refIssuanceForm"
			      id="IssuanceForm"
			      action>

        <div id="pageErrors"
				     class="alert alert-danger"
				     v-if="pageErrors.length>0">
					<p>
						<b>Please correct the following error(s):</b>
						<ul>
							<li v-for="error in pageErrors"
							    :key="error">{{ error }}</li>
						</ul>
					</p>
				</div>
				<div id="Customerror"
				     class="alert alert-danger"
				     role="alert"
				     v-show="customerrors.length && !errors.items.length">
					<span v-show="customerrors.length"
					      class="alert-danger">
						<b>Please correct the following error(s):</b>
						<ul>
							<li v-for="error in customerrors"
							    :key=error>{{ error }}</li>
						</ul>
					</span>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label class="required-label">Program</label>

						<div class="input-group mb-3 pl-0">
							<kendo-autocomplete id="SearchIssuanceProgram"
							                    class="form-control"
							                    name="Program"
                                  :disabled="isCorrection || editPendingCorrection"
							                    v-validate="'required'"
							                    v-model="programAutoCompleteDisplayedValue.displayedValue"
							                    :data-source="programAutoCompleteSource"
							                   :data-text-field="'Title'"
							                    :filter="'contains'"
							                    :placeholder="'Search for Program'"
							                    @select="onProgramAutoCompleteSelect"
                                  @open="onProgramOpen"
                                  @close="onProgramClose"></kendo-autocomplete>
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="fa fa-search"></i>
								</span>
							</div>
						</div>
					</div>
					<div class="form-group col-md-6">
						<label class="required-label">Partner</label>

						<div class="input-group mb-3 pl-0">
							<kendo-autocomplete id="SearchIssuancePartner"
							                    name="Partner"
							                    v-validate="'required'"
							                    class="form-control"
                                  :disabled="isCorrection || editPendingCorrection"
							                    v-model="partnerAutoCompleteDisplayedValue.displayedValue"
							                    :data-source="partnerAutoCompleteSource"
							                    :data-text-field="'FullName'"
							                    :filter="'contains'"
							                    :placeholder="'Search for Partner'"
							                    @select="onPartnerAutoCompleteSelect"
                                  @open="onPartnerOpen"
                                  @close="onPartnerClose"></kendo-autocomplete>
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="fa fa-search"></i>
								</span>
							</div>
						</div>
					</div>


				</div>

				<div class="form-row">
					<div class="form-group col-md-6">
						<label class="required-label">Unit Pool</label>
            <div id="kendo-select">
                <kendo-dropdownlist v-model="IssuanceInfo.UnitPool"
                            :data-source="dropdowns.UnitPool.dataSource"
                            :data-text-field="'Option'"
                            :option-label="'Select Unit Pool'"
                            :data-value-field="'Option'"
                            name="Unit Pool"
                           
                            @change="getOutstandingTreasuryUnits">
                </kendo-dropdownlist>   
              </div>

					</div>
					<div class="form-group col-md-6">
						<label class="required-label">Unit Class</label>            
            <div id="kendo-select">
                <kendo-dropdownlist id="dropDownUnitClass" v-model="IssuanceInfo.UnitClass"
                            :data-source="UnitClassOptions"
                            :data-text-field="'Option'"
                            :option-label="'Select Unit Class'"
                            :data-value-field="'Option'"
                            name="Unit Class"
                            @close="onUnitClassClose"
                            @change="getOutstandingTreasuryUnits">
                </kendo-dropdownlist>   
              </div>

					</div>
				</div>

				<div class="form-row">


					<div class="form-group col-md-6">
						<label>Outstanding Treasury Units</label>
						<input  disabled
						       v-model="OutstandingTreasuryUnits"
						       class="form-control"
                   >
					</div>
					<div class="form-group col-md-6">
						<label class="required-label">Units</label>
						<input type="number"
						       id="txtUnits"
						       name="Units"
						       v-validate="'required'"
						       v-model="IssuanceInfo.Unit"
						       class="form-control"
						       placeholder="Units">
					</div>
				</div>

				<div class="form-row">

					<div class="form-group col-md-6">
						<label class="required-label">Unit Type</label>
            <div id="kendo-select">
                <kendo-dropdownlist v-model="IssuanceInfo.UnitType"
                            :data-source="dropdowns.UnitType.dataSource"
                            :data-text-field="'Option'"
                            :option-label="'Select Unit Type'"
                            :data-value-field="'Option'"
                            name="Unit Type">
                </kendo-dropdownlist>   
              </div>

					</div>
					<div class="form-group col-md-6">
						<label class="required-label">Date of Issuance</label>
						<div class="input-group">
                      <kendo-datepicker
                      placeholder="Select Date"  
                      :value='IssuanceInfo.TransactionDate'
                      v-model='IssuanceInfo.TransactionDate'
                       :format="'MM/dd/yyyy'" 
                       id="dtIssuanceDate"
							             width="100%"   
                        @change="IssuanceDateChanged"
                        @open="_setCurrentDateifNull"
                        >
                       </kendo-datepicker>

						</div>
					</div>
				</div>
        <div class="form-row">
          <div class="form-group col-md-6">
						<label class="required-label">Vesting Type</label>
            <div id="kendo-select">
                <kendo-dropdownlist v-model="IssuanceInfo.VestingType"
                            :data-source="dropdowns.VestingType.dataSource"
                            :data-text-field="'Option'"
                            :option-label="'Select Vesting Type'"
                            :data-value-field="'Option'"
                            name="Vesting Type">
                </kendo-dropdownlist>   
              </div>

					</div>
        </div>
         <div class="form-row">
        <div class="form-group col-md-12">
						<label  v-bind:class="{ 'required-label': this.isCorrection || editPendingCorrection}">Notes/Comments</label>		
            <textarea class="form-control" rows="4" cols="50" id="Notes" placeholder="Notes/Comments" v-model="IssuanceInfo.Note"></textarea>
				</div>
        </div>

			</form>
		</div>
	</BaseModal>
</div>
</template>

<script>
/* eslint-disable vue/consistent-return */
import $ from "jquery";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseModelCorrection from "@/models/BaseModelCorrection.js"
import apiUtil from "@/services/apiUtil.js";
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelIssuance from "@/models/BaseModelIssuance.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js"; 
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import moment from "moment";
import funcUtil from "@/services/funcUtil.js";
import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js";
import IssuanceCorrectionConfig  from "./IssuanceCorrectionConfig.js";
import {mapGetters, mapActions, mapState } from 'vuex';
import { isNullOrUndefined } from 'util';


export default {
  name: "IssuanceForm",
  props: {
    IssuanceInfo: {},
    IssuanceModalLabel: {},
    partnerAutoCompleteDisplayedValue: {},
    programAutoCompleteDisplayedValue: {},
    ProgramUnitClassJsonData: {},
    isCorrection:{default:false},
    editPendingCorrection:{default:false}
  },
  mixins: [apiUtil, funcUtil,VestingScheduleDatesMixin],
  computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),

    UnitClassOptions() {
      //console.log("before");
      var ddlValue = [];
      this.ProgramUnitClassJsonData.option.forEach(element => {
        let option = {Option:element.UnitClass};
        ddlValue.push(option);
      });

      return ddlValue;
    },
     IsSmaller: function () {
       if(this.IssuanceInfo.Unit && this.OutstandingTreasuryUnits)
       {
         return this.IssuanceInfo.Unit <= this.OutstandingTreasuryUnits ;
       }
      
    }
  },
  data: function() {
    return {
      BaseModelIssuance: BaseModelIssuance,
      BaseModelProgram: BaseModelProgram,
      BaseModelPartner: BaseModelPartner,
      BaseModelCorrection:BaseModelCorrection,
      IssuanceCorrectionConfig:IssuanceCorrectionConfig,
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelVestingSchedule:BaseModelVestingSchedule,
      BaseModelUnitRunningTotal:BaseModelUnitRunningTotal,
      displayErrors: false,
      BaseModelInputControl: BaseModelInputControl,
      dropdowns: {
        PartnerStatus: { model: "", dataSource: [] },
        PartnerType: { model: "", dataSource: [] },
        UnitClass: { model: "", dataSource: [] },
        UnitType: { model: "", dataSource: [] },
        VestingType: { model: "", dataSource: [] },
        StateSource: { model: "", dataSource: [] },
        IncomeSource: { model: "", dataSource: [] },
        UnitPool:{ model: "", dataSource: [] },

      },
      customerrors:[],
      pageErrors : [],
      programAutoCompleteSource: [],
      partnerAutoCompleteSource: [],
      OutstandingTreasuryUnits:0,
      bProgramValid:true,
      bPartnerValid:true

    };
  },
  methods: {
    ...mapActions("postModule",['UpdateItems','CreateItems']),
    onPartnerAutoCompleteSelect(e) {
      this.bPartnerValid=true;
      this.autocompleteValue = e.dataItem.Id;
      //this.programId = to.params.programId
      // this.PartnerId = e.dataItem.Id;
      this.IssuanceInfo.ReceiverId = e.dataItem.Id;
      this.IssuanceInfo.ReceiverFullName = e.dataItem.FullName;

    },
    onPartnerOpen(){
      this.bPartnerValid=false;
    },
    onPartnerClose(){
      if (!this.bPartnerValid) {
        this.IssuanceInfo.ReceiverId = null;
        this.IssuanceInfo.ReceiverFullName = null
      }
    },
    onUnitClassClose(e){
        this.IssuanceInfo.UnitClass = e.sender.value();
    },
    onProgramAutoCompleteSelect(e) {
      this.bProgramValid=true;
      this.autocompleteValue = e.dataItem.Id;

      this.IssuanceInfo.ProgramId = e.dataItem.Id;
      this.IssuanceInfo.ProgramTitle = e.dataItem.Title;      
      
      // //Calculating Outstanding Treasury Units
      this.getOutstandingTreasuryUnits();

      let unitClassQuery = { filter: "Program/Id eq " + e.dataItem.Id }
      this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, unitClassQuery);
      console.log("unit class",this.ProgramUnitClassJsonData.option )

      // we can remove this later, if we save it to actual sharepoint instead of DB.JSON
      this.IssuanceInfo.ProgramTitle = e.dataItem.Title;
      this.IssuanceInfo.ProgramAlias = e.dataItem.Alias;
      this.IssuanceInfo.ProgramEIN = e.dataItem.EIN;
      this.IssuanceInfo.ProgramFormationDate = e.dataItem.FormationDate;
      this.IssuanceInfo.ProgramFinalCloseDate = e.dataItem.FinalCloseDate;
      this.IssuanceInfo.ProgramMultiClass = e.dataItem.MultiClass;
      this.IssuanceInfo.ProgramIncomeSource = e.dataItem.IncomeSource;
      this.IssuanceInfo.ProgramStateSource = e.dataItem.StateSource;
    },
    onProgramOpen(){
      this.bProgramValid=false;
    },
    onProgramClose(){
      if (!this.bProgramValid) {
        this.IssuanceInfo.ProgramId = null;
        this.IssuanceInfo.ProgramTitle = null
      }
    },
     Validate(){
      const self=this;
      self.pageErrors = [];
      let form=self.IssuanceInfo;
      // console.log(form)
      //Form Validations
      if (!(form.ProgramTitle && form.ProgramId)) {
        self.pageErrors.push('Program is required');
      }      
      if (!(form.ReceiverFullName && form.ReceiverId)) {
        self.pageErrors.push('Partner is required');
      }
      //Unit Pool
      if (form.UnitPool=="") {
        self.pageErrors.push('Unit Pool is required');
      }
      //Unit Class
      if (form.UnitClass=="") {
        self.pageErrors.push('Unit Class is required');
      } 
      //units
      if (!form.Unit || form.Unit<=0) {
        self.pageErrors.push('Units Field is Required and Should be greater than Zero');
      }      
      
      //Unit Type
      if (form.UnitType=="") {
        self.pageErrors.push('Unit Type is required');
      }

      //Vesting Type
      if (isNullOrUndefined(form.VestingType) || form.VestingType=="") {
        self.pageErrors.push('Vesting Type is required');
      }
      
      if (form.TransactionDate=="" || form.TransactionDate==null) {
        self.pageErrors.push('Date of Issuance is required');
      }

      if (!(self.isCorrection || self.editPendingCorrection) && (self.IssuanceInfo.Unit>self.OutstandingTreasuryUnits  && self.IssuanceInfo.UnitPool === "Treasury")) {
        self.pageErrors.push('Units must be less than or equal to Outstanding Treasury Units');
      }
      if((form.Note==""||form.Note==null)&& (self.isCorrection || self.editPendingCorrection))
      {
       self.pageErrors.push('Note/Comments is required');
      }
      if (self._validateSpecialCharacter(form.Note,"multiline")) {
        self.pageErrors.push(`Notes/Comments cannot have ${this.MultiLineSpecialChars}  Characters`);
      }

      return self.pageErrors.length>0 ? false:true
    },
    getOutstandingTreasuryUnits(){
      this.calculateOutstandingTreasuryUnits(this.IssuanceInfo);
      
    },
    calculateOutstandingTreasuryUnits(issuanceInfo){
      let self = this;
       let form=issuanceInfo;

      if (issuanceInfo.UnitPool=="New" || self.isCorrection || self.editPendingCorrection) {
        self.OutstandingTreasuryUnits="Not Applicable";

      
        return;
      }
      
      self.OutstandingTreasuryUnits=0;
     
      if (form.ProgramId && form.ProgramTitle && form.UnitClass!="" ) {
        let response = this.withFilter(BaseModelUnitRunningTotal.list,{filter: "Program/Id eq " + form.ProgramId +" and Partner/Id eq 1"})
        // console.log("outstanding Treasury Units response: " , response );
        let filteredResponse=_.filter(response, function(item){
            return item.UnitClass==form.UnitClass
        })
        if (filteredResponse[0]) {
            self.OutstandingTreasuryUnits=filteredResponse[0].Unit;
        }        
        console.log("outstanding Treasury Units: " , this.OutstandingTreasuryUnits ); 
      }
    },
    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // self._getInputControls().then(response => {
        console.log(response);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });
      // });
    },

    async saveChanges() {
      let self=this;
      this.displayErrors = true;
      // this.$validator.validate().then(result => {
        if (self.Validate()) {
          if (this.IssuanceModalLabel.modalAddorEdit == "add") {
            // Add Popup
            this.IssuanceInfo.Status = "Pending";
            this.IssuanceInfo.BusinessEvent = "Issuance";
            //console.log(JSON.stringify(this.IssuanceInfo));

            //Vesting Schedule Date Changes
            let VestingScheduleResponse=self.withFilter(self.BaseModelVestingSchedule.list,{filter: "Program/Id eq " + self.IssuanceInfo.ProgramId +" and UnitClass eq "+"'"+self.IssuanceInfo.UnitClass +"'"})
            self._getVestingDates(this.IssuanceInfo,VestingScheduleResponse);
            
            self._updateHireDate(this.IssuanceInfo);
            
            var addFormValues = this.IssuanceInfo;

            let createItem = { list:this.BaseModelIssuance, payload:addFormValues };
            //let loader = this.$loading.show();
            this._APICrudPopup("APICrudpopup");
            this.CreateItems(createItem).then((res) => {
              $("#issuanceGrid")
                  .data()
                  .kendoGrid.dataSource.read();
                  this._AlertPopup("Data Saved Successfully!","success");            
            }).catch(error=>{
              this._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
             // loader.hide();
            })

          } else {
            // Edit Popup
            console.log(JSON.stringify(this.IssuanceInfo));
            var editForm = this.IssuanceInfo;

            //let loader ;
            if(self.isCorrection)
            {
              let userResponse= await this._ConfirmationPopup("Please confirm for creating correction for this record","confirm");
              if (userResponse.value) {
                //loader = this.$loading.show();
                this._APICrudPopup("APICrudpopup");
              editForm.Status = "Correction Pending"
                let ItemToUpdate = { list:IssuanceCorrectionConfig, payload:editForm };
                  try {
                      let updateResponse=await self.UpdateItems(ItemToUpdate);
                
                      editForm.Status = "Pending";
                      editForm.BusinessEvent = "Issuance";
                      editForm.CorrectionID= editForm.Id;
                      editForm.CorrectionDate=new Date();
                      let createditem= {list: self.BaseModelCorrection,payload: editForm};

                      if (updateResponse) {
                        let createResponse= await self.CreateItems(createditem);
                      }
                      
                      $("#issuanceReportGrid").data().kendoGrid.dataSource.read();
                      this._AlertPopup("Correction created  Successfully!","success");
                  }catch{
                      this._AlertPopup("Some Error Occurred!","info");
                  }
                    //loader.hide()
              }
            }else if(self.editPendingCorrection){
              //edit pedning Correction
              //loader = this.$loading.show();
              this._APICrudPopup("APICrudpopup");
              let updateItem = { list:this.BaseModelCorrection, payload:editForm };
              this.UpdateItems(updateItem).then((res) => {
                  $("#CorrectionGrid").data().kendoGrid.dataSource.read();
                  this._AlertPopup("Correction Edited Successfully!","success"); 
              }).catch(error=>{
                this._AlertPopup("Some Error Occurred!","info");
              }).finally(()=>{
                //loader.hide();
                $("#"+self.IssuanceModalLabel.modalIdandRef).modal("toggle");
              }) 
            }
            else
            {
              //loader = this.$loading.show();
              this._APICrudPopup("APICrudpopup");
              let updateItem = { list:this.BaseModelIssuance, payload:editForm };
                this.UpdateItems(updateItem).then((res) => {
                      $("#issuanceGrid")
                      .data()
                      .kendoGrid.dataSource.read();
                      //loader.hide();
                      this._AlertPopup("Data Saved Successfully!","success");
                  
                }).catch(error=>{
                  this._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                  //loader.hide();
                }) 
            }
            

          }
          // alert("Data Saved Successfully!");          
          
          $("#BaseModal").modal("toggle");
          this.resetFields();
        }
      // });
    },
    resetFields: function() {
      this.displayErrors = false;
      this.errors.clear();
      this.customerrors=[];
      this.pageErrors=[];
    },
    getProgramAutoCompleteData() {

      this.programAutoCompleteSource = this.withFilter(BaseModelProgram.list);
    },
    getPartnerAutoCompleteData() {
       let partnerFilterQuery ={
		batchQuery:true,
        filter : function(o){
           return o.PartnerStatus !='Retired Employee' && o.PartnerStatus !='Former Employee'
        },
		limit: 5000
	}
       
      
      this.partnerAutoCompleteSource = this.withFilter(BaseModelPartner.list,partnerFilterQuery);
    },
    checkUnits: function () {
      this.customerrors = [];

      if (!this.IsSmaller  && this.IssuanceInfo.UnitPool === "Treasury") {
        this.customerrors.push('Units must be less than or equal to Outstanding Treasury Units');
      }

      if (!this.customerrors.length) {
        return true;
      }
    },
    IssuanceDateChanged: function(e){
      // console.log(e)
      var self = this;
      var UnitPoolTreasury = false;   
      // var SelectedDate = moment(e).format("MM/DD/YYYY");
      var SelectedDate = new Date(e);      
      SelectedDate.setHours(0, 0, 0, 0);
      console.log("date selected " + SelectedDate);
      var ProgramVestingScheduleItems = [];
      if(self.IssuanceInfo.ProgramId != "" && self.IssuanceInfo.ProgramId != null){

        let response = this.withFilter(BaseModelVestingSchedule.list,{filter: "Program/Id eq " + self.IssuanceInfo.ProgramId });
        ProgramVestingScheduleItems = response;
        console.log(ProgramVestingScheduleItems);
        var VestingItemsFiltered = ProgramVestingScheduleItems.filter(obj => {
          return obj.UnitClass == self.IssuanceInfo.UnitClass && obj.UnitType == self.IssuanceInfo.UnitType
          });
          console.log(VestingItemsFiltered);
        // VestingItemsFiltered.forEach(item => {
         UnitPoolTreasury= VestingItemsFiltered.some(item =>{
         var VestingDate = new Date(item.VestDate);
         VestingDate.setHours(0, 0, 0, 0);              
         if(SelectedDate >= VestingDate){
           return true;
         }
        });

        if(UnitPoolTreasury){
           // Issuance Date is on or after the vesting Date
           self.IssuanceInfo.UnitPool = "Treasury";
         }else{
           // Issuance Date is before the vesting Date
           self.IssuanceInfo.UnitPool = "New";
         }

      // });
      }


    },
  },
  mounted() {
     this.getInputControls();
     
    this.resetFields();
    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });

    this.getProgramAutoCompleteData();
    this.getPartnerAutoCompleteData();

    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("SearchIssuanceProgram");
    this.ShowAutoCompleteListOnFocus("SearchIssuancePartner");

    this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, '')
  },
  components: {
    BaseModal
  }
};
</script>
<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}



</style>
